module.exports = __webpack_public_path__ + "img/base_restauration_restaurant.1635240e.svg";